import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import PageHero from "../components/PageHero";
import ContactCTA from "../components/ContactCTA";
import { productCategories } from "../data/mock";
import { ArrowUpRight, Check } from "lucide-react";

const Services = () => {
  return (
    <PageLayout>
      <PageHero
        badge="Our Capabilities"
        title="Wire, Cable & Connection Services"
        subtitle="From mil-spec assemblies to fiber-optic backbones — we design, engineer and install across every common standard."
        breadcrumbs={[{ label: "Services" }]}
      />

      <section className="py-20" style={{ backgroundColor: "#f7faf8" }}>
        <div className="max-w-[1280px] mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {productCategories.map((p) => (
            <Link
              key={p.id}
              to={`/services/${p.slug}`}
              className="group block bg-white rounded-3xl overflow-hidden border border-slate-100 hover:border-emerald-200 hover:shadow-2xl hover:shadow-emerald-500/10 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="relative aspect-[5/3] overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a2e1f]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
                  <ArrowUpRight size={18} className="text-emerald-700" />
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold mb-2 group-hover:text-emerald-700 transition-colors" style={{ color: "#0a2e1f" }}>
                  {p.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4">{p.description}</p>
                <ul className="space-y-1.5">
                  {p.features.slice(0, 3).map((f, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-slate-700">
                      <Check size={14} className="text-emerald-600 mt-0.5 shrink-0" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <ContactCTA />
    </PageLayout>
  );
};

export default Services;
